import { isStandalonePWA } from "@/utils/url-utils";

export type ClientChannel = "web" | "pwa" | "mobile";

function readViteEnv(name: string): string | undefined {
  const env = import.meta.env as Record<string, string | undefined>;
  const value = env[name];
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
}

export type ClientContextPayload = {
  client: {
    channel: ClientChannel;
    os: string;
    appVersion: string | null;
    commitSha: string | null;
  };
  screen?: string;
};

export function getClientChannelHeader(): ClientChannel {
  if (typeof window === "undefined") return "web";
  return isStandalonePWA() ? "pwa" : "web";
}

export function getClientContext(extra?: { screen?: string }): ClientContextPayload {
  const channel = getClientChannelHeader();
  let os = "web";

  if (typeof navigator !== "undefined") {
    const ua = navigator.userAgent;
    if (/Android/i.test(ua)) os = "android";
    else if (/iPhone|iPad|iPod/i.test(ua)) os = "ios";
    else if (/Windows/i.test(ua)) os = "windows";
    else if (/Mac/i.test(ua)) os = "macos";
    else if (/Linux/i.test(ua)) os = "linux";
  }

  const commitSha = readViteEnv("VITE_COMMIT_SHA") ?? null;
  const appVersion =
    readViteEnv("VITE_APP_VERSION") ?? (commitSha ? commitSha.slice(0, 7) : null);

  return {
    client: {
      channel,
      os,
      appVersion,
      commitSha,
    },
    ...(extra?.screen
      ? { screen: extra.screen }
      : typeof window !== "undefined"
        ? { screen: window.location.pathname }
        : {}),
  };
}
